import { BookOpen, FileText } from 'lucide-react';
import knowledgeData from '../../data/knowledge.json';

interface KnowledgeItem {
  id: number;
  title: string;
  category: string;
  description: string;
  readTime: string;
}

const knowledgeArticles: KnowledgeItem[] = knowledgeData;

export function Knowledge() {
  return (
    <div className="py-12">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl mb-4">Knowledge Base</h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Access technical resources, guides, and best practices to help you make informed decisions
          </p>
        </div>

        {/* Search and Filter Section */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-12">
          <div className="flex flex-col md:flex-row gap-4">
            <input
              type="text"
              placeholder="Search knowledge base..."
              className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
            />
            <button className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 py-3 rounded-lg transition-colors">
              Search
            </button>
          </div>
        </div>

        {/* Articles Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {knowledgeArticles.map((article) => (
            <div
              key={article.id}
              className="bg-white rounded-lg shadow-md p-6 hover:shadow-xl transition-shadow cursor-pointer"
            >
              <div className="flex items-start justify-between mb-4">
                <BookOpen className="text-primary flex-shrink-0" size={32} />
                <span className="text-sm text-gray-600">{article.readTime}</span>
              </div>
              <span className="inline-block bg-primary/20 text-primary px-3 py-1 rounded-full text-sm mb-3">
                {article.category}
              </span>
              <h3 className="text-xl mb-3">{article.title}</h3>
              <p className="text-gray-700 mb-4">{article.description}</p>
              <button className="text-primary hover:text-primary/80">
                Read Article →
              </button>
            </div>
          ))}
        </div>

        {/* FAQ Section */}
        <div className="bg-gray-50 rounded-lg p-8">
          <h2 className="text-3xl mb-8 text-center">Frequently Asked Questions</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl mb-3">How do I choose the right hydraulic pump?</h3>
              <p className="text-gray-700">
                Consider factors such as flow rate, pressure requirements, fluid type, and operating environment.
                Our technical team can help you select the optimal pump for your application.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl mb-3">What is the warranty on your products?</h3>
              <p className="text-gray-700">
                All our products come with a standard 12-month warranty against manufacturing defects.
                Extended warranty options are available for specific product lines.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl mb-3">Do you offer technical support?</h3>
              <p className="text-gray-700">
                Yes, we provide comprehensive technical support including installation guidance,
                troubleshooting assistance, and maintenance recommendations.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl mb-3">How long does shipping take?</h3>
              <p className="text-gray-700">
                Standard shipping typically takes 3-5 business days for domestic orders.
                International shipping times vary by destination. Express shipping options are available.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
